import React from "react";
import Cookies from "js-cookie";
import comingsoon from "../images/comingsoonFinalimage.png";

// The first launch is US only. India is still offered in the country picker so
// visitors can tell us where they are, but selecting it lands here instead of
// the storefront. This also catches anyone whose country cookie was set to INR
// before the US-only launch.
const IndiaComingSoon = () => {
  const switchToUS = () => {
    Cookies.set("country", "USD", { expires: 7, path: "" });
    window.location.href = "/";
  };

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center px-3"
      style={{ minHeight: "100vh" }}
    >
      <img
        src={comingsoon}
        alt=""
        style={{ width: "min(420px, 80vw)", objectFit: "contain" }}
      />

      <h1 className="mt-3" style={{ fontSize: "28px" }}>
        The Resale Bazaar is coming to India
      </h1>

      <p
        className="text-secondary mt-2"
        style={{ maxWidth: "520px", lineHeight: "30px", fontSize: "18px" }}
      >
        We have launched in the United States first while we get shipping and
        payments right for India. We would rather do it properly than early.
      </p>

      <p
        className="text-secondary"
        style={{ maxWidth: "520px", fontSize: "16px" }}
      >
        Shopping from the US, or happy to browse in dollars? The full store is
        open.
      </p>

      <button
        type="button"
        className="btn btn-dark mt-2 px-4"
        onClick={switchToUS}
      >
        Shop the US store
      </button>

      <p className="text-secondary mt-4" style={{ fontSize: "14px" }}>
        Questions in the meantime:{" "}
        <a
          href="mailto:theresalebazaar@gmail.com"
          className="text-decoration-none"
        >
          theresalebazaar@gmail.com
        </a>
      </p>
    </div>
  );
};

export default IndiaComingSoon;
